var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{attrs:{"drag":"","action":"","before-upload":_vm.beforeUpload,"show-file-list":false}},[(!_vm.val)?_c('div',[_c('i',{staticClass:"el-icon-upload"}),_c('div',{staticClass:"el-upload__text"},[_vm._v("点击或拖拽上传图片")])]):_c('img',{staticStyle:{"height":"100%"},attrs:{"src":_vm.val,"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }